/** 全站页脚 / 版权信息（与路由、导航保持一致） */
export const SITE_META = {
  siteName: 'CoolPeople',
  domain: 'CoolPeople.com.cn',
  company: '广州丰捷软件技术有限公司',
  icp: '粤ICP备15110461号-5',
  icpUrl: 'https://beian.miit.gov.cn/',
  tagline: '连接有趣的人和分享经验的地方'
}

export function getCopyrightYear() {
  return new Date().getFullYear()
}

/**
 * 「认识人」统一入口（顶栏 / 移动端 / 页脚共用）
 * 文案与路由保持一致：动态列表、发布动态、找人、推荐、喜欢、聊天、谁看过我
 */
export const SOCIAL_NAV_LINKS = [
  { to: '/moment', label: '动态' },
  { to: '/moment/create', label: '发布动态', auth: true },
  { to: '/search', label: '找人' },
  { to: '/people', label: '推荐' },
  { to: '/like', label: '喜欢' },
  { to: '/chat', label: '聊天', auth: true },
  { to: '/visite', label: '谁看过我' }
]

/** 桌面端页脚分栏 */
export const FOOTER_COLUMNS = [
  {
    id: 'product',
    title: '产品',
    links: [
      { to: '/', label: '首页' },
      { to: '/blogs', label: '编辑推荐' },
      { to: '/exames', label: '心智测试' },
      { to: '/knowledge/courses', label: '知识课程' },
      { to: '/referral/bind-coupon', label: '绑定礼券' },
      { to: '/download-app', label: '下载 APP' }
    ]
  },
  {
    id: 'social',
    title: '认识人',
    links: SOCIAL_NAV_LINKS.map(({ to, label }) => ({ to, label }))
  },
  {
    id: 'support',
    title: '支持与关于',
    links: [
      { to: '/about', label: '关于 CoolPeople' },
      { to: '/help', label: '帮助中心' },
      { to: '/feedback', label: '意见反馈' },
      { to: '/contact', label: '联系我们' },
      { to: '/team', label: '团队介绍' }
    ]
  }
]

/** 移动端：「其他」下拉菜单（原页脚链接，不含主导航已展示的「朋友」项） */
export const MOBILE_OTHER_LINKS = [
  { to: '/download-app', label: '下载 APP' },
  { to: '/about', label: '关于 CoolPeople' },
  { to: '/help', label: '帮助中心' },
  { to: '/feedback', label: '意见反馈' },
  { to: '/contact', label: '联系我们' },
  { to: '/team', label: '团队介绍' }
]

/** @deprecated 使用 MOBILE_OTHER_LINKS */
export const MOBILE_FOOTER_LINKS = MOBILE_OTHER_LINKS

/** 移动端「认识人」下拉 */
export const MOBILE_FRIEND_LINKS = SOCIAL_NAV_LINKS.map(({ to, label }) => ({ to, label }))
